import { NgModule } from '@angular/core';
import { BrCurrencyPipe, TruncatePipe } from './br-currency.pipe';
import { AmountPipe } from './amount.pipe';
import { OrderStatusPipe } from './order-status.pipe';
import { CnpjMaskPipe, DocumentMaskPipe } from './cnpj-mask.pipe';

@NgModule({
  declarations: [
    BrCurrencyPipe,
    AmountPipe,
    TruncatePipe,
    OrderStatusPipe,
    CnpjMaskPipe,
    DocumentMaskPipe,
  ],
  exports: [
    BrCurrencyPipe,
    AmountPipe,
    TruncatePipe,
    OrderStatusPipe,
    CnpjMaskPipe,
    DocumentMaskPipe,
  ],
})
export class CustomPipeModule {}
